import React from 'react';
import { useTranslation } from 'react-i18next';
import DashboardLayout from '../components/dashboard/DashboardLayout';
import QuestBoard from '../components/quests/QuestBoard';
import Leaderboard from '../components/quests/Leaderboard';

const QuestsPage = () => {
  const { t } = useTranslation();
  return (
    <DashboardLayout>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">{t('quests.title')}</h1>
        <p className="text-gray-500 mt-1">{t('quests.subtitle')}</p>
      </div>

      <div className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <QuestBoard />
        </div>
        <div>
          <Leaderboard />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default QuestsPage;
